import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgSwitchViewLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M18 3.99939L23 8.99939M23 8.99939L18 13.9994M23 8.99939H10M6 9.99939L1 14.9994M1 14.9994L6 19.9994M1 14.9994H14"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgSwitchViewLarge.displayName = 'SvgSwitchViewLarge';
const SwitchViewLarge = withForgeIconProps(SvgSwitchViewLarge, {
  name: 'SwitchView',
  usage: 'Use to switch to an alternate page view.',
  related: 'swap',
  isLabelRequired: true,
  isNeutralInteractive: false,
  size: 'large',
});
export default SwitchViewLarge;
